import { Box, Pagination } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { news } from "./data";

const News = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [page, setPage] = useState(1);
  const rowsPerPage = 5;

  const handleChangePage = (event, value) => {
    setPage(value);
    window.scrollTo(0, 0);
  };

  const paginateNews = news.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <Box>
      <Box
        sx={{
          paddingX: isMobile ? 4 : 24,
          paddingY: isMobile ? 3 : 6,
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #eee",
        }}
      >
        <h1
          style={{
            fontSize: "28px",
            color: "#333",
            letterSpacing: "1px",
            textTransform: "uppercase",
            fontWeight: "600",
            margin: 0,
          }}
        >
          {t("menu.news")}
        </h1>
      </Box>

      <Box
        className="content"
        sx={{ paddingX: isMobile ? 4 : 24, paddingY: isMobile ? 1 : 3 }}
      >
        {paginateNews.map((item) => (
          <div
            key={item.id}
            className="single-news"
            style={{
              borderBottom: "1px solid lightgray",
              paddingBottom: "20px",
              marginBottom: "20px",
            }}
          >
            <span>{item.date}</span>
            <Link
              to={`/news/details/${item.id}`}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              <h3
                style={{
                  width: isMobile ? "100%" : "70%",
                  fontSize: "24px",
                  color: "#442872",
                  fontWeight: "600",
                  lineHeight: "1.5",
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
              >
                {t(item.content)}
              </h3>
            </Link>
            <p style={{ color: "#555", fontSize: "15px" }}>{t(item.content)}</p>
          </div>
        ))}
      </Box>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center", padding: "20px" }}>
        <Pagination
          count={Math.ceil(news.length / rowsPerPage)}
          page={page}
          onChange={handleChangePage}
          color="primary"
        />
      </Box>
    </Box>
  );
};

export default News;
